import { Component, OnDestroy, OnInit } from '@angular/core';
import { InquiryCreationStep } from '@webapp/core/interfaces';
import { PublicInquiryManagerService } from 'projects/webapp/app/services/public-inquiry-manager.service';
import { Subject, distinctUntilChanged, map, skip, takeUntil } from 'rxjs';

@Component({
  selector: 'app-public-inquiry',
  templateUrl: './public-inquiry.component.html',
  styleUrl: './public-inquiry.component.scss'
})
export class PublicInquiryComponent implements OnInit, OnDestroy {
  currentStep: InquiryCreationStep = 1;

  /** Everything between the welcome screen and the summary: the sidebar layout. */
  get isFormStep() {
    return this.currentStep !== 1 && this.currentStep !== 'summary';
  }

  protected _destroy$ = new Subject<void>();

  constructor(protected _publicInquiryManagerService: PublicInquiryManagerService) {
  }

  ngOnInit(): void {
    const step$ = this._publicInquiryManagerService.inquiryCreationProgress$.pipe(
      map(progress => progress?.currentStep ?? 1),
      distinctUntilChanged(),
      takeUntil(this._destroy$),
    );

    step$.subscribe(step => this.currentStep = step);

    // "Weiter" sits below a long card; the next step starts at its top.
    step$.pipe(skip(1)).subscribe(() => window.scrollTo({ top: 0 }));
  }

  ngOnDestroy() {
    this._destroy$.next();
    this._destroy$.complete();
  }
}
